import { httpGet, httpPost } from '@/services'

// 获取调查信息
export const getFormDetail = (params = {}) => httpGet({ url: '/survey/get', params })

// 提交调查信息
export const submitForm = (data = {}) => httpPost({ url: '/survey/submit', data })
